import { useEffect } from 'react'
import { Badge, Flex, FormControl, FormHelperText, FormLabel, Text } from '@chakra-ui/react'
import { addDays, format, parse } from 'date-fns'

import { CUSTOM_FORM_KIND_NAME } from 'components/tools/CustomForm/constants'
import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'
import CustomFormViewerQuestionSelection from '../../../components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection'

export default function RecessoBolsista() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch, setValue } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const inicioDoAfastamento = watch ? watch(`form_answers.${titleForQuestion['Data de início do recesso']}`) : undefined
  const numeroDeDiasDeAtestado = watch ? watch(`form_answers.${titleForQuestion['Quantidade de dias']}`) : undefined
  const inicioDoAfastamentoSegundoPeriodo = watch
    ? watch(`form_answers.${titleForQuestion['Data de início do recesso - segundo período']}`)
    : undefined

  useEffect(() => {
    if (inicioDoAfastamento && numeroDeDiasDeAtestado) {
      try {
        const parsedDate = parse(inicioDoAfastamento, 'dd/MM/yyyy', new Date())
        const finalDate = addDays(parsedDate, Number(numeroDeDiasDeAtestado.split(' ')[0]) - 1)
        const formatted = format(finalDate, 'dd/MM/yyyy')

        setValue(`form_answers.${titleForQuestion['Término do recesso']}`, formatted)
      } catch (err) {
        // Data inválida
        setValue(`form_answers.${titleForQuestion['Término do recesso']}`, '')
      }
    }
  }, [inicioDoAfastamento, numeroDeDiasDeAtestado, setValue])

  useEffect(() => {
    if (inicioDoAfastamentoSegundoPeriodo && numeroDeDiasDeAtestado) {
      try {
        const parsedDate = parse(inicioDoAfastamentoSegundoPeriodo, 'dd/MM/yyyy', new Date())
        const finalDate = addDays(parsedDate, Number(numeroDeDiasDeAtestado.split(' ')[0]) - 1)
        const formatted = format(finalDate, 'dd/MM/yyyy')

        setValue(`form_answers.${titleForQuestion['Término do recesso - segundo período']}`, formatted)
      } catch (err) {
        // Data inválida
        setValue(`form_answers.${titleForQuestion['Término do recesso - segundo período']}`, '')
      }
    }
  }, [inicioDoAfastamentoSegundoPeriodo, numeroDeDiasDeAtestado, setValue])

  useEffect(() => {
    if (numeroDeDiasDeAtestado == '30 dias') {
      setValue(`form_answers.${titleForQuestion['Data de início do recesso - segundo período']}`, '')
      setValue(`form_answers.${titleForQuestion['Término do recesso - segundo período']}`, '')
    }
  }, [numeroDeDiasDeAtestado])

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        //Data de início do recesso - segundo período
        if (
          question.title == 'Data de início do recesso - segundo período' ||
          question.title == 'Término do recesso - segundo período'
        ) {
          if (numeroDeDiasDeAtestado == '15 dias') {
            return (
              <Flex key={index} bg="bgContent" rounded="md" p={2} flexDir="column">
                <FormControl gap={2}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="borderColor"
                    pb={2}
                    mb={2}
                  >
                    <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                    <Text variant="secondary">
                      <Text as="span">{Number(index) + 1}</Text>
                      <Text as="span">/{questions?.length}</Text>
                    </Text>
                  </Flex>
                  <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                  {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                  <CustomFormViewerQuestionSelection question={question} disabled={false} />
                </FormControl>
              </Flex>
            )
          } else {
            // Aqui a questão deve ser removida
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
